<template>
  <scroll-layout>
    <template slot="header">
      <div class="button-wrap">
        <ykc-button type="plain" @click="$router.go(-1)">返回</ykc-button>
      </div>
    </template>

    <div class="content">
      <ykc-detail-plus :labelWidth="110">
        <div slot="header" class="clearfix">
          <span class="title">电站信息</span>
        </div>
        <ykc-detail-item-plus label="电站名称">
          {{ detail.stationName || '——' }}
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="电站编码">
          {{ detail.stationCode || '——' }}
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="电站状态">
          {{ detail.stationStatus === 1 ? '启动' : '停用' }}
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="白名单状态">
          {{ detail.whitelistStatus === 1 ? '已开启' : '未开启' }}
        </ykc-detail-item-plus>
      </ykc-detail-plus>

      <div class="user-search">
        <el-input
          size="mini"
          v-model="keyword"
          placeholder="请输入用户名称/账号/ID"
          clearable
          @keyup.enter.native="handleSearch"></el-input>
        <ykc-button @click="handleSearch">查询</ykc-button>
      </div>

      <ykc-table
        style="margin-top: 16px"
        ref="YkcTable"
        :data="tableData"
        :columns="tableColumns"
        title="白名单用户列表"
        :operateButtons="[]">
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="total"
          :current-page.sync="currentPage"
          @current-change="handlePaginationCurrentChange"
          :page-size.sync="pageSize"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
  </scroll-layout>
</template>

<script>
  import { operationsStationChargeWhitelist } from '@/service/apis';

  export default {
    name: 'StationChargeWhitelistDetail',
    data() {
      return {
        stationId: '',
        detail: {},
        keyword: '',
        tableData: [],
        total: 0,
        currentPage: 1,
        pageSize: 10,
        tableColumns: [
          { label: '用户名称', prop: 'userName' },
          { label: '用户账号', prop: 'userAccount' },
          { label: '用户ID', prop: 'userId' },
          {
            label: '添加时间',
            prop: 'createdTime',
            scopedSlots: {
              default: ({ row }) => <span>{this.formatTime(row.createdTime)}</span>,
            },
          },
          { label: '添加人', prop: 'createdByName' },
        ],
      };
    },
    created() {
      this.stationId = Number(this.$route.query.stationId);
      this.getDetail();
      this.getListData();
    },
    methods: {
      getDetail() {
        operationsStationChargeWhitelist.detail({ stationId: this.stationId }).then(res => {
          this.detail = res || {};
        });
      },
      getListData() {
        operationsStationChargeWhitelist
          .userPage({
            stationId: this.stationId,
            keyword: this.keyword,
            current: this.currentPage,
            size: this.pageSize,
          })
          .then(res => {
            this.tableData = res?.records || [];
            this.total = res?.total || 0;
          });
      },
      handleSearch() {
        this.currentPage = 1;
        this.getListData();
      },
      handlePaginationCurrentChange(current) {
        this.currentPage = current;
        this.getListData();
      },
      handlePaginationSizeChange(size) {
        this.currentPage = 1;
        this.pageSize = size;
        this.getListData();
      },
      formatTime(time) {
        if (!time) {
          return '——';
        }
        return String(time).replace('T', ' ').slice(0, 19);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .content {
    .clearfix {
      height: 19px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 19px;
    }
  }
  .user-search {
    display: flex;
    gap: 8px;
    width: 360px;
    margin-top: 16px;
  }
</style>
